import { URL_WEB } from "../constants/urls/urlWeb";

export type GetURLFromDeeplinkProps = {
  deeplink: string;
  type?: "path" | "showcase" | "full";
};

export const getURLFromDeeplink = ({
  deeplink,
  type = "path",
}: GetURLFromDeeplinkProps): string => {
  if (!deeplink) return null;
  let pieces;
  if (!deeplink.startsWith("hallow")) {
    if (!deeplink.startsWith("http")) return null;
    if (type === "full") return deeplink; // we want hallow.com in it
    pieces = deeplink.split("hallow.com/");
    if (pieces.length < 2) return deeplink; // some external URL
  } else {
    pieces = deeplink.split("hallow://");
    if (pieces.length < 2) return null;
  }

  if (type === "path") return `/${pieces[1]}`;
  if (type === "full") return `${URL_WEB}/${pieces[1]}`;

  const linkPieces = pieces[1].split("/");
  return `/${linkPieces[0]}/${linkPieces[1]}`;
};
